import { SxProps, Theme } from '@mui/material';

const styles: SxProps<Theme> = {
  displayPrint: 'none',
};

export default styles;
